
export const LOGIN_MUTATION_QUERY = `
	mutation signIn($token: String!) {
		signIn(token: $token) {
			token
			organizationId
			user {
				id
				email
				name
				isRedeemedMapped
				roles
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/app/shared/models/query.ts